export default {
  computed: {
    basicBinaryOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true
      }, {
        label: this.$t("application-form.no"),
        value: false
      }];
    },
    binaryTrueShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "show"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "hide"
      }];
    },
    binaryFalseShowsOptions() {
      return [{
        label: this.$t("application-form.yes"),
        value: true,
        action: "hide"
      }, {
        label: this.$t("application-form.no"),
        value: false,
        action: "show"
      }];
    },
    downPaymentSourceOptions() {
      return [{
        label: this.$t("application-form.sales-of-existing-property"),
        value: "sales-of-existing-property"
      }, {
        label: this.$t("application-form.personal-cash"),
        value: "personal-cash"
      }, {
        label: this.$t("application-form.rrsp"),
        value: "rrsp"
      }, {
        label: this.$t("application-form.borrowed-against-liquid-assets"),
        value: "borrowed-against-liquid-assets"
      }, {
        label: this.$t("application-form.gift"),
        value: "gift"
      }, {
        label: this.$t("application-form.sweat-equity"),
        value: "sweat-equity"
      }, {
        label: this.$t("application-form.existing-equity"),
        value: "existing-equity"
      }, {
        label: this.$t("application-form.secondary-financing"),
        value: "secondary-financing"
      }, {
        label: this.$t("application-form.grants"),
        value: "grants"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    mortgageRequestedOptions() {
      return [{
        label: this.$t("application-form.requested"),
        value: "requested"
      }, {
        label: this.$t("application-form.existing"),
        value: "existing"
      }];
    },
    loanTypeOptions() {
      return [{
        label: this.$t("application-form.mortgage"),
        value: "mortgage"
      }, {
        label: this.$t("application-form.secured-loc"),
        value: "secured-loc"
      }];
    },
    mortgageTypeOptions() {
      return [{
        label: this.$t("application-form.first"),
        value: "first"
      }, {
        label: this.$t("application-form.second"),
        value: "second"
      }, {
        label: this.$t("application-form.third"),
        value: "third"
      }];
    },
    lineOfBusinessOptions() {
      return [{
        label: "A",
        value: "a"
      }, {
        label: "B",
        value: "b"
      }, {
        label: "C",
        value: "c"
      }];
    },
    locRepaymentOptions() {
      return [{
        label: "5/20",
        value: "5-20"
      }, {
        label: "10/15",
        value: "10-15"
      }];
    },
    rateTypeOptions() {
      return [{
        label: this.$t("application-form.fixed"),
        value: "fixed"
      }, {
        label: this.$t("application-form.adjustable"),
        value: "adjustable"
      }, {
        label: this.$t("application-form.capped-variable"),
        value: "capped-variable"
      }, {
        label: this.$t("application-form.variable"),
        value: "variable"
      }, {
        label: this.$t("application-form.buy-down"),
        value: "buy-down"
      }];
    },
    termTypeOptions() {
      return [{
        label: this.$t("application-form.closed"),
        value: "closed"
      }, {
        label: this.$t("application-form.open"),
        value: "open"
      }, {
        label: this.$t("application-form.convertible"),
        value: "convertible"
      }];
    },
    frequencyOptions() {
      return [{
        label: this.$t("application-form.monthly"),
        value: "monthly"
      }, {
        label: this.$t("application-form.semi-monthly"),
        value: "semi-monthly"
      }, {
        label: this.$t("application-form.biweekly"),
        value: "biweekly"
      }, {
        label: this.$t("application-form.accelerated-biweekly"),
        value: "accelerated-biweekly"
      }, {
        label: this.$t("application-form.weekly"),
        value: "weekly"
      }, {
        label: this.$t("application-form.accelerated-weekly"),
        value: "accelerated-weekly"
      }];
    },
    compoundingPeriodOptions() {
      return [{
        label: this.$t("application-form.semi-annually"),
        value: "semi-annually"
      }, {
        label: this.$t("application-form.monthly"),
        value: "monthly"
      }];
    },
    noteCategoryOptions() {
      return [{
        label: this.$t("application-form.general"),
        value: "general"
      }, {
        label: this.$t("application-form.admin"),
        value: "admin"
      }, {
        label: this.$t("application-form.source-of-business"),
        value: "source-of-business"
      }, {
        label: this.$t("application-form.decisioning"),
        value: "decisioning"
      }, {
        label: this.$t("application-form.mi-response"),
        value: "mi-response"
      }, {
        label: this.$t("application-form.deal-ingestion"),
        value: "deal-ingestion"
      }];
    },
    payoffOptions() {
      return [{
        label: this.$t("application-form.prior-to-advance"),
        value: "prior-to-advance"
      }, {
        label: this.$t("application-form.from-proceeds"),
        value: "from-proceeds"
      }, {
        label: this.$t("application-form.other"),
        value: "other"
      }];
    },
    insuranceProviderOptions() {
      return [{
        label: "CMHC",
        value: "cmhc"
      }, {
        label: this.$t("application-form.genworth"),
        value: "genworth"
      }, {
        label: this.$t("application-form.canada-guaranty"),
        value: "canada-guaranty"
      }];
    }
  }
};